import React from "react";
import vegArt from "../../images/veg-art.png";

function MainComponent() {
    return <main style={{height: "766px", marginTop: "115px"}}>
         <section className="d-flex justify-content-center align-items-center h-100">
            <img src={vegArt} alt=""/>
         </section>
      </main>
    
}

export default MainComponent